import { provideHttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { API_CONFIG, ApiGatewayConfig } from '@thiememeulenhoff/ng-api-gateway';

@NgModule({
  providers: [provideHttpClient()],
})
export class StoreModule {
  static forRoot(config: ApiGatewayConfig): ModuleWithProviders<StoreModule> {
    return {
      ngModule: StoreModule,
      providers: [
        {
          provide: API_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
